import { FC, useRef, useEffect } from 'react';
import { Box } from '@material-ui/core';
import debounce from 'lodash.debounce';

import { useApplications } from 'store/applications/hooks';
import { revenueTimePeriodOptions } from 'core/constants';
import { TimePeriod } from 'store/applications/types';
import { RangeNumberInput } from '../../RangeNumberInput';

const RevenueFilter: FC = () => {
  const {
    filters: { minRevenue, maxRevenue, revenuePeriod = TimePeriod.MONTHLY },
    updateApplicationsQuery,
  } = useApplications();

  const debouncedUpdateAppsQuery = useRef(debounce(updateApplicationsQuery, 1000)).current;

  useEffect(() => {
    return () => {
      debouncedUpdateAppsQuery.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChangeMinRevenue = (revenue: number) => {
    debouncedUpdateAppsQuery({ minRevenue: revenue });
  };

  const onChangeMaxRevenue = (revenue: number) => {
    debouncedUpdateAppsQuery({ maxRevenue: revenue });
  };

  const onChangeRevenueTimePeriod = (timePeriod: TimePeriod) => {
    updateApplicationsQuery({ revenuePeriod: timePeriod });
  };

  return (
    <Box>
      <RangeNumberInput
        minValue={minRevenue}
        maxValue={maxRevenue}
        onChangeMinValue={onChangeMinRevenue}
        onChangeMaxValue={onChangeMaxRevenue}
        withPrefix
        options={revenueTimePeriodOptions}
        timePeriodValue={revenuePeriod}
        onChangeTimePeriod={onChangeRevenueTimePeriod}
      />
    </Box>
  );
};

export default RevenueFilter;
